import * as _ from "lodash";

import PagosImpuestosGlobalesCalculator from "./PagosImpuestosGlobalesCalculator";

class PagosImpuestosCalculator {
  data = {};

  constructor(data) {
    this.data = _.cloneDeep(data);
  }

  apply() {
    this.withImpuestosGlobales();

    return this;
  }

  get() {
    return this.data;
  }

  withImpuestosGlobales() {
    let pagos = this.data || [];

    for (const pago of pagos) {
      const impuestos = new PagosImpuestosGlobalesCalculator(pago).apply();

      if (!!impuestos) {
        pago.ImpuestosP = impuestos;
      }
    }

    return this;
  }
}

export default PagosImpuestosCalculator;
